import React from 'react';
import { Form, Input, InputNumber } from 'antd';
const { Group } = Input;

const ProductionYear = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Год выпуска" help={null}>
      <Group compact style={{ width: '100%' }}>
        {getFieldDecorator('production_year_from')(
          <InputNumber
            style={{ width: '50%' }}
            placeholder="от"
            min={1980}
            max={2019}
          />
        )}
        {getFieldDecorator('production_year_to')(
          <InputNumber
            style={{ width: '50%' }}
            placeholder="до"
            min={1980}
            max={2019}
          />
        )}
      </Group>
    </Form.Item>
  );
};

export default ProductionYear;
